<template>
  <m-pay-layout>

      <v-layout justify-center align-top class="mx-2">
        <v-flex grow>
          <m-pay-generic-paging-table
            :headers="headers"
            :queryFunctionName="queries.merchantShippingMethods.name"
            :cellClasses="cellClasses"
          >
            <template slot-scope={item} slot="details">
              <router-link :to="{ name: 'shipping-method', params: { id: item.id } }">
                <v-tooltip bottom>
                      <span slot="activator">
                        <v-icon color="secondary">zoom_in</v-icon>
                      </span>
                  <span>Method Details</span>
                </v-tooltip>
              </router-link>
            </template>
            <template slot-scope={item} slot="enabled">
              <span v-if="item.enabled == 1">Yes</span>
                <span v-if="item.enabled == 0">No</span>
            </template>

          </m-pay-generic-paging-table>
          <v-btn class="ml-0"
               color="secondary"
               @click.native="addShippingMethod">
            Add
            <v-icon right dark>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

    </m-pay-layout>
</template>

<script>
import MPayGenericPagingTable from '../MPayGenericPagingTable';
import MPayStatus from '../MPayStatus';


export default {
  name: 'MPayMerchantShippingMethodsPage',
  components: { MPayGenericPagingTable, MPayStatus },
  data: () => ({
    merchantShippingMethods: [],
    totalMerchantShippingMethods: 0,
    merchant: {},
    headers: [
      { text: '', value: 'details', sortable: false, filterable: false },
      { text: 'ID', value: 'id', align: 'center', sortable: true, filterable: true },
      { text: 'Name', value: 'name', filterable: true },
      { text: 'Method', value: 'methodName', filterable: true },
      { text: 'External ID', value: 'extId', filterable: true },
      { text: 'Enabled', value: 'enabled', filterable: true },
    ],
    cellClasses: {
      details: 'pl-3 pr-1',
    },
    loading: false,
  }),
  methods: {
    addShippingMethod() {
      this.$router.push({ name: 'add-shipping-method' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantShippingMethodsPage.vue